import { Navigate, Outlet } from 'react-router-dom';

import { Footer } from './footer/Footer';
import { Header } from './header/Header';

type props = {
  isLogin: boolean;
};

export const PublicLayout = ({ isLogin }: props) => {
  return isLogin ? (
    <Navigate to="/admin/" />
  ) : (
    <div className="relative min-h-[100vh] bg-solid-gray-100 pb-10">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};
